import { render, staticRenderFns } from "./mapText.vue?vue&type=template&id=2b842ab6&scoped=true"
var script = {}
import style0 from "./mapText.vue?vue&type=style&index=0&id=2b842ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b842ab6",
  null
  
)

export default component.exports